export default "__VITE_ASSET__Cwqp2Xoe__"